/** @format */

import React, { useEffect } from "react";
import { Container, Row } from "reactstrap";

import CashierForm from "./VerticalValidationWizard";

export default function AddCashier({ cashier_id }) {
  return (
    <div className="page-body main-project">
      <Container fluid className="mt-3">
        <Row>
          <CashierForm cashier_id={cashier_id} />
        </Row>
      </Container>
    </div>
  );
}
